import {queryBearerToken} from "./UserAuthentication";
import * as ActionTypes from "../constants/ActionTypes";
import {queryBaseArticle} from "./ArticleData";
import {addItemToCart, queryNewCart} from "./Cart";
import {toggleSelectionTriggered} from "./Util";
import {appInitialized} from "./AppInit";
import {isNextcloudArticle, isNonUsualArticleType} from "../selectors/ArticleNumbers";
import {selectCartProperty} from "./Properties";
import {_initialSoftware} from "../selectors/GetParam";
import {getBaseArticle} from "../selectors/SimpleSelectors";
import {putSimpleFormData} from "./FormData";

/**
 * Standalone initializing method. It doesn't provide neos or any other articledata loading.
 * @param baseArticleId
 * @param initParams
 * @returns {Function}
 */
export const initializeAppSimple = (baseArticleId, initParams) => (dispatch, getState) => {


    const {initialArticles/*initialPromotionCode, initialDomains, initialContractDuration*/} = initParams

    Promise.all([
        dispatch(queryBearerToken())
    ]).then((args) => {
        if (args[0].type !== ActionTypes.BEARER_TOKEN_FAILURE) {

            const initialCalls = [
                queryBaseArticle(baseArticleId),
                queryNewCart()
            ]

            Promise.all(initialCalls.map(func => dispatch(func))).then((args) => {
                if (args[0].type === ActionTypes.BASE_ARTICLE_SUCCESS && args[1].type === ActionTypes.CART_CREATE_SUCCESS) {
                    Promise.all([
                        dispatch(addItemToCart(baseArticleId))
                    ]).then((args) => {

                        const baseArticle = getBaseArticle(getState());

                        dispatch({
                            type: ActionTypes.BASE_ARTICLE_LOAD_COMPLETE
                        })

                        const postInitCalls = []

                        // add initial articles
                        if (initialArticles && initialArticles.length > 0) {
                            initialArticles.forEach(articleNumber => {
                                postInitCalls.push(addItemToCart(articleNumber))
                            })
                        }

                        // pre-select phone verification
                        postInitCalls.push(toggleSelectionTriggered('phoneVerificationType', 'phone'))


                        if (isNextcloudArticle(baseArticleId)) {

                            dispatch(selectCartProperty("software", "nextcloud"));

                        } else if (!isNonUsualArticleType(baseArticle.type) && _initialSoftware) {

                            dispatch(selectCartProperty("software", _initialSoftware));

                        }

                        Promise.all(postInitCalls.map(func => dispatch(func))).then(args => {

                            dispatch(appInitialized(initParams))
                            dispatch(putSimpleFormData())

                        })
                    })
                }
            })
        }
    })

}


/** WEBPACK FOOTER **
 ** ./src/actions/AppInit.Simple.js
 **/